import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {FooterComponent} from "../../../base/components/footer/footer.component";
import {Store} from '@ngrx/store';
import {selectAllExploreProjects} from '../../../project/service/project.selectors';
import {loadExploreProjects} from '../../../project/service/project.actions';
import {ExploreProjectCardComponent} from '../explore-project-card/explore-project-card.component';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {toSignal} from '@angular/core/rxjs-interop';
import {startWith} from 'rxjs';

@Component({
  selector: 'app-explore',
  imports: [
    FooterComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    ExploreProjectCardComponent
  ],
  templateUrl: './explore.component.html',
  styleUrl: './explore.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExploreComponent {
  private readonly store: Store = inject(Store);

  searchControl = new FormControl('');
  readonly projects = this.store.selectSignal(selectAllExploreProjects);
  readonly searchTerm = toSignal(this.searchControl.valueChanges.pipe(startWith('')), {initialValue: ''});

  readonly filteredProjects = computed(() => {
    const projects = this.projects();
    const searchTerm = this.searchTerm();
    if (!searchTerm) {
      return projects;
    }

    const search = searchTerm.toLowerCase().trim();
    return projects.filter(project =>
      project.name.toLowerCase().includes(search) ||
      (project.topic && project.topic.toLowerCase().includes(search))
    );
  });

  constructor() {
    this.store.dispatch(loadExploreProjects());
  }
}
